import React from "react";

interface IProps {
  siteUrl: string;
  organizationName?: string;
  organizationAlternateName?: string;
  description?: string;
  socials?: Array<{ platform: string; url: { url: string } }>;
  contactNumber?: string;
}

const OrganizationSchema = (props: IProps) => {
  const {
    siteUrl,
    organizationName,
    organizationAlternateName,
    description,
    socials,
    contactNumber,
  } = props;
  const sameAs =
    socials?.map((social) => social.url?.url).filter(Boolean) || [];

  const schema: Record<string, any> = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: organizationName || "OTTO by Rockwell Automation",
    url: siteUrl,
    logo: `${siteUrl}/icons/icon-512x512.png`,
    description:
      description ||
      "OTTO by Rockwell Automation is the leading provider of autonomous mobile robots (AMRs) for material handling in manufacturing and warehousing.",
    parentOrganization: {
      "@type": "Organization",
      name: "Rockwell Automation",
      url: "https://www.rockwellautomation.com",
    },
  };

  if (organizationAlternateName) {
    schema.alternateName = organizationAlternateName;
  }

  if (sameAs.length > 0) {
    schema.sameAs = sameAs;
  }

  if (contactNumber) {
    schema.contactPoint = {
      "@type": "ContactPoint",
      telephone: contactNumber.replace("tel:", ""),
      contactType: "sales",
    };
  }

  return (
    <script type="application/ld+json">{JSON.stringify(schema)}</script>
  );
};

export default OrganizationSchema;
